// maximum holding time for each trade
export const Maximum_Holding_Time = '3 hours 30 minutes'